export const FormattedNumber = ({ value, uom, maxLength = 8, isTruncateMiddle = false }) => {
    if (!value) return '-';
    
    const numValue = parseFloat(value);
    
    const formatWithCommas = (num) => {
        return num.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 20
        });
    };
    
    const truncateNumber = (num) => {
        const str = num.toString();
        
        const digits = str.replace(/[^0-9]/g, '');
        
        if (digits.length <= 5) return str;
        
        let digitCount = 0;
        let truncateIndex = 0;
        
        for (let i = 0; i < str.length; i++) {
            if (/[0-9]/.test(str[i])) {
                digitCount++;
                if (digitCount === 5) {
                    truncateIndex = i + 1;
                    break;
                }
            }
        }
        
        return str.substring(0, truncateIndex) + '...';
    };

     function truncateMiddle(text, maxLength) {
        if (!text) return "";
        if (text.length <= maxLength) return text;

        // Ensure minimum 3 characters visible (1…1)
        const minVisible = Math.max(1, Math.floor(maxLength / 4));

        const head = Math.max(minVisible, Math.ceil(maxLength / 3));
        const tail = Math.max(minVisible, Math.floor(maxLength / 3));

        // If maxLength is too small, show first few chars + …
        if (head + tail > maxLength) {
            return text.slice(0, maxLength - 1) + "…";
        }

        return text.slice(0, head) + "…" + text.slice(-tail);
    }
    
    const truncatedValue = isTruncateMiddle ? truncateMiddle(value?.toString(), maxLength) : truncateNumber(numValue);
    const fullFormattedValue = formatWithCommas(value);
    // const truncatedValue = truncateNumber(numValue);
    // const fullFormattedValue = formatWithCommas(numValue);
    
    return (
        <span title={fullFormattedValue}>
            {truncatedValue} <span className="fs-6">{uom}</span>
        </span>
    );
};

export const FormattedNumbers = ({ value, uom, showUom = true }) => {
  //  if (!value || value === 0) return '-';
    
    const numValue = parseFloat(value);
    
    const formatWithCommas = (num) => {
        return num.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 20
        });
    };
    
    const truncateNumber = (num) => {
        const str = num.toString();
        
        const digits = str.replace(/[^0-9]/g, '');
        
        if (digits.length <= 5) return str;
        
        let digitCount = 0;
        let truncateIndex = 0;
        
        for (let i = 0; i < str.length; i++) {
            if (/[0-9]/.test(str[i])) {
                digitCount++;
                if (digitCount === 5) {
                    truncateIndex = i + 1;
                    break;
                }
            }
        }
        
        return str.substring(0, truncateIndex) + '...';
    };
    
    const truncatedValue = truncateNumber(numValue);
    const fullFormattedValue = formatWithCommas(numValue);
    
    return (
        <span title={fullFormattedValue}>
            {truncatedValue} {showUom && uom ? uom : ''}
        </span>
    );
};